var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "26px",
    viewBox: "0 0 30 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1--Sign-in-&-Security---Logins-A",
    transform: "translate(-382.000000, -852.000000)",
    fill: "#0077B5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.285818,860.382214 L389.285818,877.770174 L383.209319,877.770174 L383.209319,860.382214 L389.285818,860.382214 Z M389.686032,855.003416 C389.686032,856.672981 388.366467,858.008909 386.24769,858.008909 L386.208858,858.008909 C384.168836,858.008909 382.85,856.672981 382.85,855.003416 C382.85,853.298537 384.209003,852 386.287735,852 C388.366467,852 389.646593,853.298537 389.686032,855.003416 Z M411.2,867.800449 L411.199757,877.770174 L405.1235,877.770174 L405.1235,868.467606 C405.1235,866.131 404.244196,864.536564 402.044477,864.536564 C400.365716,864.536564 399.365788,865.611446 398.926621,866.64963 C398.765953,867.021696 398.726515,867.540095 398.726515,868.059764 L398.726515,877.770636 L392.649287,877.770636 C392.649287,877.770636 392.729378,862.014272 392.649287,860.382675 L398.726515,860.382675 L398.726515,862.845534 C399.533009,861.661594 400.977443,859.973911 404.203664,859.973911 C408.202281,859.973911 411.2,862.45962 411.2,867.800449 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9ac873eb0bdcee4068a4c395f3acfbf8.svg";
export { ForwardRef as ReactComponent };